import React from 'react'
import find from 'lodash/find'

import {
  Card,
  CardHeader,
  CardText,
  CardTitle
} from 'material-ui/Card'

import api from '../../api'
import Edit from './edit'
import Create from './create'

class HeaderBlock extends React.Component<any, any> {
  constructor () {
    super()
    this.state = {
      blockTypes: [],
      headerBlock: {},
      page: {}
    }
  }

  componentWillMount () {
    this.fetchBlockTypes()
    this.fetchPage().then(this.fetchHeaderBlock.bind(this))
  }

  render () {
    const { blockTypes, headerBlock, page } = this.state
    const blockType = find(blockTypes, { type: headerBlock.block_type })

    return (
      <div>
        <CardTitle title='Header' />
        {blockType && (
          <Card>
            <CardHeader
              title='Header Block'
              subtitle='This block will be displayed within the page header.'
            />
            <CardText>
              <Edit
                target='cms_page_blocks'
                blockType={blockType}
                pageBlock={headerBlock}
                onBlockUpdated={this.handleBlockUpdated.bind(this)}
                onBlockDeleted={this.handleBlockDeleted.bind(this)}
              />
            </CardText>
          </Card>
        )}

        {page && !blockType && (
          <Card>
            <CardHeader title='Configure Header Block' />
            <CardText>
              <Create
                target='cms_page_blocks'
                cmsPageProp='cms_page_id'
                cmsPageId={this.props.cmsPageId}
                blockTypes={blockTypes}
                onBlockCreated={this.handleBlockCreated.bind(this)}
                onCancel={this.handleCancelCreate.bind(this)}
              />
            </CardText>
          </Card>
        )}
      </div>
    )
  }

  handleBlockCreated (block) {
    const body = {
      header_block_id: block.id
    }

    api.patch(`admin/cms_pages/${this.state.page.id}`, { body })
      .then(res => res.json())
      .then(data => {
        this.setState({
          headerBlock: block
        })
      })
  }

  handleBlockUpdated (block) {
    const body = {
      header_block_id: block.id
    }

    api.patch(`admin/cms_pages/${this.state.page.id}`, { body })
      .then(res => res.json())
      .then(data => {
        this.setState({
          headerBlock: block
        })
      })
  }

  handleBlockDeleted (block) {
    this.setState({
      headerBlock: {}
    })
  }

  handleCancelCreate () {
    this.setState({
      headerBlock: {}
    })
  }

  fetchBlockTypes () {
    return api.get('admin/cms_block_types')
      .then(res => res.json())
      .then(data => {
        this.setState({
          blockTypes: data.filter(block => block.category === 'header')
        })
      })
  }

  fetchPage () {
    return api.get(`admin/cms_pages/${this.props.cmsPageId}`)
      .then(res => res.json())
      .then(data => {
        this.setState({
          page: data
        })

        return data
      })
  }

  fetchHeaderBlock (page) {
    const blockId = page.header_block_id

    if (blockId) {
      return api.get(`admin/cms_page_blocks/${blockId}`)
        .then(res => res.json())
        .then(data => {
          this.setState({
            headerBlock: data
          })
        })
    }
  }
}

// @ts-ignore
HeaderBlock.propTypes = {
  cmsPageId: React.PropTypes.string.isRequired
}

export default HeaderBlock
